// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".E2uq3knhuPd102PIX8mN5g\\=\\={display:flex;align-items:center;justify-content:center;margin-bottom:8px;cursor:pointer;padding:8px;border-radius:4px;transition:background-color .2s ease}.E2uq3knhuPd102PIX8mN5g\\=\\=:hover{background-color:rgba(0,0,0,.05)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"releasedButton": "E2uq3knhuPd102PIX8mN5g=="
};
export default ___CSS_LOADER_EXPORT___;
